import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import _ from 'underscore';
import OptimizationScoreTemplate from './optimization-score.pug';

export class OptimizationScoreColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'OptimizationScore',
      property: 'OptimizationScore',
      title: i18n.getString('ColumnName_OptimizationScore'),
      sortable: 'OptimizationScore',
      bodyClasses: ['grid-column-OptimizationScoreColumn'],
      type: 'number',
      helpId: 'Pop_BA_Recommendations_OptScoreAcct',
    });
    this.i18n = i18n;
  }

  pickProperty(item) {
    const { Id: cpid, Name } = item;
    const ariaLabel = this.i18n.getString('Click to scope to the recommendation with campaign {{campaignName}}', { campaignName: Name });
    return {
      display: _.has(item, 'OptimizationScore'), OptimizationScore: _.result(item, 'OptimizationScore', null), cpid, ariaLabel,
    };
  }

  template({ value }) {
    const newProps = _.defaults({ value: this.formatter(value.OptimizationScore), pathname: '/campaign/vnext/recommendations/All' }, value);
    return OptimizationScoreTemplate(newProps);
  }

  get formatter() {
    if (!this.cached.formatter) {
      this.cached.formatter = val =>
        (_.isFinite(val) ?
          _.compose(this.i18n.percentToFixedFormatter({ digits: 1 }), Number)(val)
          : val);
    }
    return this.cached.formatter;
  }
}
